module.exports = __webpack_public_path__ + "static/pic2-60378ec9f6f56a80fe5523c3d9568dc4.jpg";